const COOKIE_FIRST_LOCAL_STORAGE_NAME = 'cookiefirst-consent'
const OMIT_CONSENT = 'calibre-omit-consent'

class CookieFirstHelper {
  constructor() {
    if (CookieFirstHelper.Singleton) return
    CookieFirstHelper.Singleton = this
  }

  getConsent() {
    if (_omitConsent()) return true

    let consent = localStorage.getItem(COOKIE_FIRST_LOCAL_STORAGE_NAME)

    return consent ? JSON.parse(consent) : null
  }

  getPerformanceConsent() {
    const consent = this.getConsent()
    return consent ? consent.performance : false
  }

  getFunctionalConsent() {
    const consent = this.getConsent()
    return consent ? consent.functional : false
  }

  openSettings() {
    globalThis.window?.CookieFirst?.openPanel?.()
  }
}

const _omitConsent = () => document.cookie.includes(OMIT_CONSENT)

export default new CookieFirstHelper()
